<template>
    <div>

        <el-form :model="from" :rules="rules" ref="from" style="padding: 0 10%;" label-width="100px">
            <el-form-item label="项目名称" prop="project_id">
                <el-select v-model="from.project_id" placeholder="请选择项目" style="width: 100%;" filterable>
                    <el-option v-for="item in $parent.$parent.projectList" :key="item.id" :label="item.project_name"
                        :value="item.id">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="宿舍名称" prop="dormitory_name">
                <el-input v-model="from.dormitory_name" placeholder="请输入宿舍名称" style="width: 100%;"></el-input>
            </el-form-item>
            <el-form-item label="宿舍地址" prop="dormitory_address">
                <el-input v-model="from.dormitory_address" placeholder="请输入宿舍地址" style="width: 100%;"></el-input>
            </el-form-item>
            <el-form-item label="负责人姓名" prop="staff_id">
                <el-select v-model="from.staff_id" placeholder="请选择负责人" style="width: 100%;" filterable>
                    <el-option v-for="item in $parent.$parent.staffList" :key="item.id" :label="item.staff_name"
                        :value="item.id">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="负责人电话" prop="staff_phone">
                <el-input v-model="from.staff_phone" placeholder="请输入负责人电话" style="width: 100%;"></el-input>
            </el-form-item>
            <el-form-item style="text-align: center;" label-width="0px">
                <el-button type="primary" @click="Add"
                    style="width: 30%; background-color: #006E4B; border: 1px solid #006E4B;">保存</el-button>
            </el-form-item>
        </el-form>

    </div>
</template>

<script>
    import axios from "axios";
    export default {
        data() {
            var checkPhone = (rule, value, callback) => {
                if (!value) {
                    return callback(new Error('手机号不能为空'));
                } else {
                    const reg = /^1[3|4|5|7|8][0-9]\d{8}$/
                    console.log(reg.test(value));
                    if (reg.test(value)) {
                        callback();
                    } else {
                        return callback(new Error('请输入正确的手机号'));
                    }
                }
            };
            return {
                //表单数据
                from: {
                    project_id: "",
                    dormitory_name: "",
                    dormitory_address: "",
                    staff_id: "",
                    staff_phone: ""
                },

                //表单验证
                rules: {
                    project_id: [{
                        required: true,
                        message: '请选择项目',
                        trigger: 'blur'
                    }],
                    dormitory_name: [{
                        required: true,
                        message: '请输入宿舍名称',
                        trigger: 'blur'
                    }],
                    dormitory_address: [{
                        required: true,
                        message: '请输入宿舍地址',
                        trigger: 'blur'
                    }],
                    staff_id: [{
                        required: true,
                        message: '请选择负责人',
                        trigger: 'blur'
                    }],
                    staff_phone: [{
                        required: true,
                        validator: checkPhone,
                        trigger: 'blur'
                    }],
                }
            };
        },
        methods: {
            Add() {
                this.$refs["from"].validate((valid) => {
                    if (valid) {

                        const url = this.$globals.http + "dormitory/add";
                        axios.post(url, {
                            project_id: this.from.project_id,
                            dormitory_name: this.from.dormitory_name,
                            dormitory_address: this.from.dormitory_address,
                            staff_id: this.from.staff_id,
                            staff_phone: this.from.staff_phone,
                        }).then((response) => {
                            var code = response.data.code;
                            var data = response.data.data;

                            if (code === '200') {

                                this.$message.success(data);
                                this.Return();

                            } else {
                                this.$message.warning("请求失败！请稍后重试");
                            }
                        }).catch((error) => {
                            console.log(error)
                            this.$message.error("服务器未响应！请稍后重试");
                        })

                    }
                });
            },
            Return() {
                this.from.project_id = "";
                this.from.dormitory_name = "";
                this.from.dormitory_address = "";
                this.from.staff_id = "";
                this.from.staff_phone = "";
                this.$parent.$parent.Return('add');
            },
        },
        created() {

        }
    }
</script>

<style>
</style>



// WEBPACK FOOTER //
// SsfjGl_add.vue?b922cb7e